<div class="add-money-container">
  <form (ngSubmit)="submitAddMoney()" [formGroup]="addMoneyForm">
    <div class="row p-2">
      <div class="col-sm-6">
        <div class="label-holder">
          <span class="content-label" translate>pages.newRetailer.addMoney</span>
        </div>
        <mat-card class="form-inner  content-details-blk shadow-none">
          <mat-radio-group 
            [formControl]="adminFundsRadioControl"
            (change)="selectedAccountType($event)"
          >
            <div class="row my-2">
              <div
                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
              >
              <div class="form-item-input">
                  <mat-radio-button color="primary" value="retailer"
                    >{{'pages.AutoReload.Retailer' | translate}}</mat-radio-button
                  >
                </div>
                <div class="form-item-input">
                  <mat-form-field appearance="outline" class="w-94">
                    <mat-label>{{'pages.AutoReload.RetailerName' | translate }} </mat-label>
                    <input
                      type="text"
                      placeholder="Pick one"
                      aria-label="Number"
                      matInput
                      formControlName="retailerName"
                      [matAutocomplete]="auto1"
                    />
                    <mat-autocomplete panelWidth="550px"
                      #auto1="matAutocomplete"
                      (optionSelected)="selectedRetailerName($event)"
                      [displayWith]="getOptionretailerName"
                    >
                      <mat-option
                        *ngFor="let option of filteredOptions"
                        [value]="option"
                      >
                        {{ option.retailerName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                 </div>
              </div>
              <div
                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
              >
              <div class="form-item-input">
                  <mat-radio-button color="primary" value="salesRep"
                    >{{'pages.AutoReload.Salesrep' | translate}}</mat-radio-button
                  >
                </div>
                <div class="form-item-input">
                  <mat-form-field appearance="outline" class="w-94">
                    <mat-label>SalesRep Name </mat-label>
                    <input
                      type="text"
                      aria-label="salesRepName"
                      matInput
                      placeholder="Enter Sales Rep Name"
                      formControlName="salesRepName"
                      [matAutocomplete]="auto3"
                    />
                    <mat-autocomplete class="w-100"
                      #auto3="matAutocomplete"
                      (optionSelected)="selectedSalesRepDetails($event)"
                      [displayWith]="getOptionSalesrepName"
                    >
                      <mat-option
                        *ngFor="let option of filteredSalesrepOptions"
                        [value]="option"
                      >
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              
            </div>
          </mat-radio-group>

          <div class="row my-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label><span class="translate" translate>pages.newRetailer.accountType</span></mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Account type"
                    formControlName="retailerType"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{'pages.ManageProviders.Mobilenumber' | translate }}</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="{{'pages.ManageProviders.Mobilenumber' | translate }}"
                    formControlName="otpMobileNumber"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label><span translate>pages.newRetailer.businessname</span></mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Busineess Name"
                    formControlName="businessName"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label><span translate>pages.newRetailer.dbaName</span></mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'pages.newRetailer.dbaName' | translate }}"
                    formControlName="dbaName"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label><span translate>pages.newRetailer.address</span></mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="{{'pages.AddProviders.Enteraddress' | translate }} Line1"
                    formControlName="address1"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline" class="w-100">
                  
                  <mat-label><span translate class="translate">pages.newRetailer.creditBalance</span></mat-label>
                 <input
                    matInput
                    [textMask]="{ mask: numberMask, guide: false }"
                    placeholder="{{'pages.Managefunds.EnterCreditbalance' | translate }}"
                    formControlName="currentAmount"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col-sm-6">
        <div class="label-holder">
          <span class="content-label" translate>pages.newRetailer.creditlineBalance</span>
        </div>
        <mat-card class="credit-line-blk shadow">
          <div class="credit-line-blk-inner">
            <h5 class=" mb-0" translate>pages.newRetailer.availableBalance</h5>
            <p class=" mb-0 curent-balance">
               {{ creditAvailable | currency}}
            </p>
            <mat-hint *ngIf="showLowbalanceAlert"
              ><div class="mt-3 mb-3"><span class="discounticon text-warning">
                <i class="mi mi-info icon-small"></i> Your Available Balance Is
                Less Than {{ thresholdAmnt | currency}}</span
              ></div>
            </mat-hint>
            <div class="row my-2">
              <div
                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
              >
                <h5 class="form-item-label" translate>
                  pages.newRetailer.whenMyBalanceFallsBelow<span class="required">*</span>
                </h5>
              </div>
              <div
                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
              >
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      [textMask]="{ mask: numberMask, guide: false }"
                      placeholder="{{ 'pages.newRetailer.whenMyBalanceFallsBelow' | translate }}"
                      formControlName="fallAmount"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <ng-container>
              <div class="row my-2">
                <div
                  class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.autoReloadAmount <span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        [textMask]="{ mask: numberMask, guide: false }"
                        placeholder="{{ 'pages.placeholders.AutoReloadAmount' | translate }}"
                        formControlName="autoReloadAmount"
                        required
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="form-item-input">
              <mat-checkbox
                color="primary"
                [checked]="showAutoReload"
                (change)="checkAutoReoload($event.checked)"
                [formControl]="autoReloadAlertControl"
                ><span translate class="translate">pages.newRetailer.sendAnAuto-Reload</span></mat-checkbox
              >
            </div>
            <div class="form-item-input">
              <mat-checkbox
                color="primary"
                [checked]="showbalanceAlert"
                (change)="checkReceiveLowBalAlert($event.checked)"
                [formControl]="balanceAlertControl"
              >
              <span translate class="translate">pages.newRetailer.receiveLowBalanceAlert</span></mat-checkbox
              >
            </div>
            <div class="form-item-input">
              <p translate>pages.newRetailer.sendAnAlertTo</p>
              <ul class="list-inline notify-blk">
                <li class="list-inline-item">
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      [textMask]="{ mask: phone }"
                      formControlName="mobileNumber"
                      placeholder="{{'pages.Creditlinebalance.Entermobilenumber' | translate }}"
                    />
                  </mat-form-field>
                </li>
                <li class="list-inline-item or-text">or</li>

                <li class="list-inline-item">
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="text"
                      formControlName="email"
                      placeholder="{{'pages.Creditlinebalance.EnteremailID' | translate }}"
                    />
                  </mat-form-field>
                </li>
              </ul>
            </div>
            <div class="form-footer mt-2">
              <ul class="list-inline text-center">
                <li class="list-inline-item">
                  <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    [disabled]="!addMoneyForm.valid"
                  >
                    <span translate class="translate">pages.newRetailer.addFunds</span>
                  </button>
                </li>
                <li class="list-inline-item">
                  <button
                    mat-stroked-button
                    (click)="onCancel()"
                    color="primary"
                    type="button"
                    class="rounded-0"
                  ><span translate class="translate">pages.newRetailer.cancel</span>
                    
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</div>
